export const SET_VALIDATION_ERRORS = "SET_VALIDATION_ERRORS";
export const CLEAR_VALIDATION_ERRORS = "CLEAR_VALIDATION_ERRORS";

const initialState = {
  errors: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_VALIDATION_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case CLEAR_VALIDATION_ERRORS:
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};
